var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"total",staticClass:"total"},[_c('div',{staticClass:"total__body wrap"},[_c('apex-chart',{ref:"chart",staticClass:"total__body--chart",attrs:{"options":_vm.chartOptions,"series":_vm.series,"width":_vm.size.width,"height":"auto"}}),_c('h1',{staticClass:"total__body--text",domProps:{"textContent":_vm._s(_vm.totalEmission)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }